//Props Validations
import PropTypes from "prop-types";

import { components } from "react-select";

const CustomMultiValueRemove = (props) => {
    return (
        <components.MultiValueRemove {...props}>
            <span
                style={{
                    color: "red",
                    cursor: "pointer",
                    fontSize: "12px",
                }}
            >
                &times;
            </span>{" "}
            {/* Custom remove icon */}
        </components.MultiValueRemove>
    );
};

CustomMultiValueRemove.propTypes = {
    props: PropTypes.object,
};

export default CustomMultiValueRemove;
